/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-06-25 15:38:14
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbSupplier {
    /**
     * 查询供应商下拉列表
     */
    export var GetTbSupplierDropList = (): Promise<any> => {
        return Get(`/api/TbSupplier/GetTbSupplierDropListV2`, {});
    };
    /**
     * 新增供应商
     */
    export var PostTbSupplier = (body:any): Promise<any> => {
        return Post(`/api/TbSupplier/PostTbSupplier`, body);
    };
    /**
     * 查询供应商列表
     */
    export var GetTbSupplierList = (body:any): Promise<any> => {
        return Get(`/api/TbSupplier/GetTbSupplierList`, body);
    };
    /**
     * 查询供应商详情
     */
    export var GetTbSupplierById = (body:any): Promise<any> => {
        return Get(`/api/TbSupplier/GetTbSupplierById`, body);
    };
    /**
     * 修改供应商
     */
    export var PutTbSupplier = (body:any): Promise<any> => {
        return Put(`/api/TbSupplier/PutTbSupplier`, body);
    };
    
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbSupplier.ts